import React from "react";

import "../styles.scss";
import "../scripts";

import {
  KameleonElement,
  primaryCollectionBlock,
  getDefaultProps,
  renderTertiaryBlock,
} from "@kameleon-core/lib";
import { Box } from "theme-ui";
import { webflowHOC } from "@kameleon-common/webflow-js";
import {
  BackgroundColors as ThemeBackgroundColors,
  Variants,
} from "@kameleon-util/global-theme";
import {
  blockConfig,
  ContentCollectionItem,
  ContentCollectionItemType,
} from "./components/content-collection-item";

import blockinfo from "./blockinfo.json";
import defaults from "./defaults.json";
import {
  ContentCollectionType as ComponentType,
  layoutOptions,
} from "./types/prop-types";

import getEvents from "./js/webflow";

type ContentCollectionType = {
  PrimaryBlocks: ContentCollectionItemType[];
} & ComponentType;

const Component = ({
  PrimaryBlocks,
  TertiaryBlock,
  layoutProps,
  tagline,
  heading,
  description,
}: ContentCollectionType) => {
  const primaryBlockLayoutProps = { ...layoutProps };
  primaryBlockLayoutProps.backgroundColor = ThemeBackgroundColors.neutralLight;

  return (
    <Box className="primary-collection-content-collection-two-col-flying-cards-v1 section_layout415">
      <Box className="padding-global">
        <Box className="container-large layout415_component">
          <Box className="layout415_content">
            <Box className="layout415_content-left">
              {tagline && (
                <Box className="margin-bottom margin-xsmall">
                  <Variants.TagLine>{tagline}</Variants.TagLine>
                </Box>
              )}
              <Box className="margin-bottom margin-small">
                <Variants.Heading>{heading}</Variants.Heading>
              </Box>
              <Variants.ParagraphMedium>{description}</Variants.ParagraphMedium>
              {TertiaryBlock && renderTertiaryBlock(TertiaryBlock)}
            </Box>
            <Box className="layout415_content-right">
              {PrimaryBlocks?.map((primaryBlockProps, i) => {
                const primaryProps = { ...primaryBlockProps };
                primaryProps.layoutProps = primaryBlockLayoutProps;
                return (
                  <Box key={i} className={`layout415_card card-${i}`}>
                    <ContentCollectionItem {...primaryProps} />
                  </Box>
                );
              })}
            </Box>
          </Box>
          <Box
            data-w-id="0583e246-663c-ebdc-a5f5-41bffee90e73"
            className="layout415_ix-trigger"
          />
        </Box>
      </Box>
    </Box>
  );
};

const ComponentWithWebflow = webflowHOC(Component, [
  {
    module: "ix2",
    getEvents: (pageId): object => getEvents(pageId),
  },
]);

export const ContentCollection = primaryCollectionBlock<ContentCollectionType>(
  blockConfig,
  ({ PrimaryBlocks, ...props }: ContentCollectionType) => (
    <ComponentWithWebflow PrimaryBlocks={PrimaryBlocks} {...props} />
  )
);

ContentCollection.defaultProps =
  getDefaultProps<ContentCollectionType>(defaults);

export const Element: KameleonElement = {
  component: ContentCollection,
  blockInfo: blockinfo,
  defaultProps: {
    layoutProps: defaults.layoutProps,
    contentProps: defaults.contentProps,
  },
  layoutOptions,
};
